module.exports = __webpack_public_path__ + "static/salesforce-c8620e5b4cc94228b0d3f620445d5571.png";